module.exports = __webpack_public_path__ + "static/img/phone-icon1.9059cf2c.png";